import {http} from "@/config/HttpClient";
import {Alert} from "@/addons/Alert";
import {ingresoStore} from "@/store/ingresoStore";
import {globalStore} from "@/store/globalStore";
import {AxiosResponse} from "axios";
import {DateTime} from 'luxon';

export class IngresoService{
    private static instance: IngresoService;

    baseURL= `${process.env.VUE_APP_URL}`;

    public static getInstance(){
        return this.instance || (this.instance = new this());
    }

    ingresoStore = ingresoStore();
    globalStore = globalStore();

    public async historial(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ingresoStore.loading = true;
            http.post("historial", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.ingresoStore.historial = response.data.historial
                },
                error: (error) => {
                    this.ingresoStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async getFuncionarioResponsable() {
        await http.get("funcionario_responsable").subscribe({
            next: (response:AxiosResponse) => {
                this.ingresoStore.funcionario_responsable = response.data;
            },
        })
    }

    public async getFuncionarioResponsableAutoriza() {
        await http.get("funcionario_responsable_autoriza").subscribe({
            next: (response:AxiosResponse) => {
                this.ingresoStore.funcionario_responsable_autoriza = response.data;
            },
        })
    }

    public async getTipo() {
        await http.get("getTipoIngreso").subscribe({
            next: (response:AxiosResponse) => {
                this.ingresoStore.tipo = response.data;
            },
        })
    }

    public async getEmpresaPorveedora() {
        await http.get("getEmpresaProveedora").subscribe({
            next: (response:AxiosResponse) => {
                this.ingresoStore.empresa = response.data;
            },
        })
    }

    public async getTipoSalida() {
        await http.get("getTipoSalida").subscribe({
            next: (response:AxiosResponse) => {
                this.ingresoStore.tipo = response.data;
            },
        })
    }


    public async saveIngreso(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ingresoStore.loading = true;
            http.post("saveIngreso", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.ingresoStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Ingreso a Almacenes registrado correctamente");
                        this.ingresoStore.ingreso = response.data.ingreso
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.ingresoStore.loading = false;
                    reject(error);
                }
            })
        });
    }


    public async updateIngreso(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ingresoStore.loading = true;
            http.post("updateIngreso", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.ingresoStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Ingreso actualizado correctamente");
                        this.ingresoStore.ingreso = response.data.ingreso
                        resolve(response.data);
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.ingresoStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async finalizarIngreso(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ingresoStore.loading = true;
            http.post("finalizarIngreso", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.ingresoStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Ingeso Finalizado correctamente");
                        this.ingresoStore.ingreso = response.data.ingreso;
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }


                },
                error: (error) => {
                    this.ingresoStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async confirmarIngreso(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ingresoStore.loading = true;
            http.post("confirmarIngreso", data).subscribe({
                next: (response: AxiosResponse) => {
                    this.ingresoStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr("Ingeso confirmado correctamente");
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }


                },
                error: (error) => {
                    this.ingresoStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async getNuevoCodigo() {
        await http.get("nuevo-codigo").subscribe({
            next: (response: AxiosResponse) => {
                if (response.data) {
                    this.ingresoStore.nuevoCodigo = response.data
                }
            }
        })
    }

    public async addMaterialIngreso(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ingresoStore.loading = true;
            http.post("addMaterialIngreso", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        Alert.successTotastr("Material agregado al ingreso correctamente");
                        this.ingresoStore.ingresoMaterial = response.data
                        this.ingresoStore.loading = false;
                    }
                },
                error: (error) => {
                    this.ingresoStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async showMaterial(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ingresoStore.loading = true;
            http.post("showMateriales", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        this.ingresoStore.ingresoMaterial = response.data
                        this.ingresoStore.loading = false;
                    }
                },
                error: (error) => {
                    this.ingresoStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async deleteMaterialIngreso(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ingresoStore.loading = true;
            http.post("deleteMaterialIngreso", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        Alert.successTotastr("Material eliminado del ingreso correctamente");
                        this.ingresoStore.ingresoMaterial = response.data
                        this.ingresoStore.loading = false;
                    }
                },
                error: (error) => {
                    this.ingresoStore.loading = false;
                    reject(error);
                }
            })
        });
    }
    public async updateQuantity(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ingresoStore.loading = true;
            http.post("updateQuantity", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        Alert.successTotastr("Cantidad entregada actualizada correctamente");
                        this.ingresoStore.ingresoMaterial = response.data
                        this.ingresoStore.loading = false;
                    }
                },
                error: (error) => {
                    this.ingresoStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async deleteMaterialesIngreso(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ingresoStore.loading = true;
            http.post("deleteMaterialesIngreso", data).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data.success) {
                        this.ingresoStore.ingresoMaterial = [];
                        this.ingresoStore.loading = false;
                    }
                },
                error: (error) => {
                    this.ingresoStore.loading = false;
                    reject(error);
                }
            })
        });
    }



    public async adjuntarDocumento(codigo:string, formData: any, headers:any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.ingresoStore.loading = true;
            http.post("cargarDocumento/" + codigo, formData, headers).subscribe({
                next: (response: AxiosResponse) => {
                    this.ingresoStore.loading = false;
                    if (response.data.success) {
                        Alert.successTotastr(`<h1>${response.data.message}</h1>`);
                        this.ingresoStore.ingreso = response.data.ingreso
                    } else {
                        Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                        resolve(false);
                    }
                },
                error: (error) => {
                    this.ingresoStore.loading = false;
                    reject(error);
                }
            })
        });
    }


    public async imprimirFactura(id:number) {
        await http.get(`verDocumento/${id}`).subscribe({
            next: (response:AxiosResponse) => {
                if (response.data.success === false){
                    Alert.info( `<h1 style="color: red">${response.data.message}</h1>`)
                }else {
                    //this.ingresoStore.factura = response.data;
                    window.open(
                        `${this.baseURL}verDocumento/${id}`, "_blank");
                }
            },
        })
    }

    public async imprimirIngreso(id:number) {
        await http.get(`imprimirIngresoAlmacen/${id}`).subscribe({
            next: (response:AxiosResponse) => {
                window.open(
                    `${this.baseURL}imprimirIngresoAlmacen/${id}`, "_blank");
            },
        })
    }


}